import React from 'react';
import CloseIcon from '../Assets/close.png';

const Close = () => {
    return (
        <img src={CloseIcon} alt="Close" className="h-6" />
    );
};

export default Close;